export default __webpack_public_path__ + "944a74802489584c36af6761bdf053b7.gif";